import { render, staticRenderFns } from "./ActiveEventsList.vue?vue&type=template&id=fa63ba4c&"
import script from "./ActiveEventsList.vue?vue&type=script&lang=js&"
export * from "./ActiveEventsList.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEventsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
